import { render, staticRenderFns } from "./FileTypeList.vue?vue&type=template&id=d643eb82&scoped=true"
import script from "./FileTypeList.vue?vue&type=script&lang=ts"
export * from "./FileTypeList.vue?vue&type=script&lang=ts"
import style0 from "./FileTypeList.vue?vue&type=style&index=0&id=d643eb82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d643eb82",
  null
  
)

export default component.exports